import { useId, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** На ПК список постоянный; на телефоне пользователь раскрывает его отдельно от навигации. */
export default function SearchResultsPanel({ children }: { children: ReactNode }) {
  const { t } = useTranslation('chatView');
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  return <div className="search-results-panel">
    <button type="button" className="search-results-toggle" aria-expanded={expanded} aria-controls={id}
      onClick={() => setExpanded(!expanded)}>{t(expanded ? 'search.hideResults' : 'search.showResults')}</button>
    <div id={id} className={'search-results' + (expanded ? ' expanded' : '')}>{children}</div>
  </div>;
}
